"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSearch = exports.mapSearchControlDataToTrackableData = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const trackTravelDates_1 = require("./trackTravelDates");
const trackTravelRooms_1 = require("./trackTravelRooms");
function mapSearchControlDataToTrackableData(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const searchControlEventMetadata = (data === null || data === void 0 ? void 0 : data.searchControl)
        ? {
            type: data.searchControl.type,
            travelPeriod: data.searchControl.travelPeriod
                ? (0, trackTravelDates_1.mapTravelDatesPayloadToEventMetadata)(data.searchControl.travelPeriod)
                : undefined,
            travellers: data.searchControl.travellers
                ? (0, trackTravelRooms_1.mapTravelRoomsPayloadToEventMetadata)(data.searchControl.travellers)
                : undefined,
            text: data.searchControl.text,
            airports: data.searchControl.airports,
        }
        : null;
    const filtersEventMetaData = (data === null || data === void 0 ? void 0 : data.filters)
        ? {
            flightOptions: {
                stopOvers: (_a = data.filters.flightOptions) === null || _a === void 0 ? void 0 : _a.stopOvers,
                departure: (_b = data.filters.flightOptions) === null || _b === void 0 ? void 0 : _b.departure,
                arrival: (_c = data.filters.flightOptions) === null || _c === void 0 ? void 0 : _c.arrival,
                airLines: (_d = data.filters.flightOptions) === null || _d === void 0 ? void 0 : _d.airLines,
                stopOverTime: (_e = data.filters.flightOptions) === null || _e === void 0 ? void 0 : _e.stopOverTime,
            },
            rooms: {
                boards: (_f = data.filters.room) === null || _f === void 0 ? void 0 : _f.boards,
                types: (_g = data.filters.room) === null || _g === void 0 ? void 0 : _g.types,
            },
            hotelPlanRating: data.filters.hotelPlanRating,
            tripAdvisorRating: data.filters.tripAdvisorRating,
            price: {
                max: (_h = data.filters.price) === null || _h === void 0 ? void 0 : _h.max,
            },
            attributes: {
                keys: (_j = data.filters.attributes) === null || _j === void 0 ? void 0 : _j.keys,
            },
        }
        : null;
    return Object.assign(Object.assign({}, searchControlEventMetadata), filtersEventMetaData);
}
exports.mapSearchControlDataToTrackableData = mapSearchControlDataToTrackableData;
const trackSearch = (data) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 search.run',
        eventMetadata: mapSearchControlDataToTrackableData(data),
        _clear: true,
    });
};
exports.trackSearch = trackSearch;
//# sourceMappingURL=trackSearch.js.map